import { render, staticRenderFns } from "./CompaniesDeliveryTable.vue?vue&type=template&id=cc822b74"
import script from "./CompaniesDeliveryTable.vue?vue&type=script&lang=js"
export * from "./CompaniesDeliveryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports